import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { fetchApplicationsData } from 'features/applications/applicationsThunks';

import { CommentsState } from 'types/comments';

import { createComment, getComments } from './commentsThunks';

const initialState: CommentsState = {
  comments: [],
  count: 0,
  isLoading: false,
  isSending: false
};

const commentsSlice = createSlice({
  name: 'comments',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getComments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getComments.fulfilled, (state, { payload }) => {
        state.comments = [...payload.content];
        state.count = payload.totalElements;
        state.isLoading = false;
      })
      .addCase(fetchApplicationsData.rejected, (state) => {
        state.isLoading = false;
        state.comments = [];
      })

      .addCase(createComment.pending, (state) => {
        state.isSending = true;
      })
      .addCase(
        createComment.fulfilled,
        (state, { payload }: PayloadAction<Comment>) => {
          state.isSending = false;
          state.comments = [...state.comments, payload];
          state.count += 1;
        }
      )
      .addCase(createComment.rejected, (state) => {
        state.isSending = false;
      });
  }
});

export default commentsSlice.reducer;
